/**
 * storage 存储包装类
 *
 * @author terrfly
 * @site https://www.jeepay.vip
 * @date 2021/5/8 07:18
 */
import storage from 'store'

const wrapper = {

  /* 获取当前Token **/
  getUserInfo: () => {
    return storage.get('userInfo')
  },

  /* 设置token信息 **/
  setUserInfo (userInfo) {
    storage.set('userInfo', userInfo)
  }
}
export default wrapper
